import { render, staticRenderFns } from "./p12.vue?vue&type=template&id=b8c58172&scoped=true&"
import script from "./p12.vue?vue&type=script&lang=js&"
export * from "./p12.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8c58172",
  null
  
)

export default component.exports